import React, { useEffect, useState } from "react";

import {
  Divider,
  Grid,
  Button,
  Container,
  Box,
  Typography,
} from "@mui/material";

import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import { customeStyle } from "utils/style";
import CustomLayout from "views/CustomLayout";
import CustomBreadcrumbs from "components/Breadcrumbs";
import Loader from "components/Loader";
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from "constants/routeConstants";
import { GLOBAL_CURRENCY } from "constants/appConstants";
import ProductList from "./ProductList";

function queryStringToJSON(search) {
  if (!search) return {};
  var qs = search.slice(1);

  var pairs = qs.split("&");
  var result = {};
  pairs.forEach(function (p) {
    var pair = p.split("=");
    var key = pair[0];
    var value = decodeURIComponent(pair[1] || "");

    if (result[key]) {
      if (Object.prototype.toString.call(result[key]) === "[object Array]") {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  });

  return JSON.parse(JSON.stringify(result));
}

const OrderComplete = ({ breadcrumbs }) => {
  const [loader, setLoader] = useState(true);
  const [order, setOrder] = useState();
  const { search } = useLocation();
  const query = queryStringToJSON(search);
  const { orderid } = query;
  const [orderStatus, setOrderStatus] = useState("");

  const navigate = useNavigate();
  const [productList, setProductList] = useState([]);

  const statusMessages = {
    "Order Placed": "Your order has been placed successfully.",
    Confirmed: "Your order has been confirmed successfully.",
    Packed: "Your order has been packed successfully.",
    Shipped: "Your order has been shipped successfully.",
    Delivered: "Your order has been delivered successfully.",
  };

  const getOrderStatus = async () => {
    // setLoader(true)
    let res = await axiosInstance.get(
      APIRouteConstants.DASHBOARD.GET_ORDER_DETAIL,
      {
        params: {
          transaction_id: orderid,
        },
      },
    );
    let { data, response } = res;

    if (response && response.status == 404) {
      setOrderStatus(_.upperCase(response.statusText));
    }
    if (!_.isEmpty(data) && data.data) {
      setOrder(data.data);

      localStorage.removeItem("localNotes");

      if (
        Array.isArray(data?.data?.order_details) &&
        data?.data?.order_details?.length > 0
      ) {
        setOrderStatus(data?.data?.order_details[0]?.delivery_status_type);
        console.log(
          "orderstatus",
          data?.data?.order_details[0]?.delivery_status_type,
        );
        // webbie-a406e6
      }
      // if (data.data.payment_status == "failed") {
      //     setOrderStatus(_.upperCase(data.data.payment_status))
      // }
      // if (data.data.payment_status == "expired") {
      //     setOrderStatus(_.upperCase(data.data.payment_status))
      // }
      // if (data.data.payment_status == "unknown") {
      //     setOrderStatus(_.upperCase(data.data.payment_status))
      // }
      // if (data.data.payment_status == "pending") {
      //     setOrderStatus(_.upperCase(data.data.payment_status))
      // }
      // if (data.data.payment_status == "successful") {
      //     setOrderStatus(_.upperCase(data.data.payment_status))
      // }
      if (_.get(data.data, "order_details"))
        setProductList(data.data.order_details);
    }
    setLoader(false);
  };

  useEffect(() => {
    if (orderid) {
      getOrderStatus();
    }
  }, [orderid]);

  const [currencySymbol, setCurrencySymbol] = useState("");
  const [storeName, setStoreName] = useState("");

  const getWebsiteInfo = async () => {
    setLoader(true);
    try {
      const res = await axiosInstance.get(APIRouteConstants.DASHBOARD.WEB_INFO);
      const { data } = res;
      setCurrencySymbol(data.currency_symbol || GLOBAL_CURRENCY.symbol);
      setStoreName(data.name || data.store_name || "");
    } catch (err) {
      console.error(err);
      setCurrencySymbol(GLOBAL_CURRENCY.symbol);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getWebsiteInfo();
  }, []);

  useEffect(() => {
    window.history.pushState(null, '', window.location.href);
    const handlePopState = () => {
      navigate('/products', { replace: true });
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [navigate]);

  return (
    <CustomLayout>
      <Container maxWidth="lg" disableGutters>
        <Box
          className="content-container"
          sx={{
            width: "100%",
            margin: "0 auto",
            px: { xs: 2, sm: 2, md: 3 },
            mt: {
              xs: "130px",
              md: "90px",
            },
          }}
        >
          <Loader open={loader} />
          <div className="content-containerr">
            <CustomBreadcrumbs
              list={breadcrumbs}
              name={`Order Status - ${orderid}`}
            />
            {/* <Divider className="divider" /> */}
            <Grid
              container
              className="ordercomplete-wrapper main-content-wrapper"
            >
              {/* <Grid container className="stepper-header">
                <div className="stepper-header-content">
                  <span
                    className="inactive"
                    style={{ fontSize: "var(--fs-lg)" }}
                  >
                    SHOPPING CART
                  </span>
                  <ArrowForwardIcon
                    style={{ marginBottom: "-3px", fontSize: "1.5rem" }}
                  />
                  <span
                    className="inactive"
                    style={{ fontSize: "var(--fs-lg)" }}
                  >
                    CHECKOUT
                  </span>
                  <ArrowForwardIcon
                    style={{ marginBottom: "-3px", fontSize: "1.5rem" }}
                  />
                  <span
                    className="active"
                    style={{
                      fontSize: "var(--fs-lg)",
                      textTransform: "uppercase",
                    }}
                  >
                    {orderStatus}
                  </span>
                </div>
              </Grid> */}

              <Grid container>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    py: { xs: 1.5, md: 2 },
                    px: { xs: 1.5, sm: 2, md: 4 },
                    backgroundColor: "#f3f4f6",
                    borderRadius: "8px",
                  }}
                >
                  {/* Step 1 – Shopping Cart (inactive) */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "6px", sm: "10px" }, flexShrink: 0 }}>
                    <Box
                      sx={{
                        width: { xs: 34, sm: 40, md: 48 },
                        height: { xs: 34, sm: 40, md: 48 },
                        borderRadius: "50%",
                        border: "1.5px solid #9ca3af",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#9ca3af",
                        flexShrink: 0,
                      }}
                    >
                      <ShoppingCartOutlinedIcon sx={{ fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.3rem" } }} />
                    </Box>
                    <Box sx={{ display: { xs: "none", sm: "block" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: { sm: "0.72rem", md: "0.85rem" }, color: "text.primary", letterSpacing: "0.03em", lineHeight: 1.3 }}>
                        SHOPPING CART
                      </Typography>
                      <Typography sx={{ fontSize: { sm: "0.65rem", md: "0.75rem" }, color: "text.secondary", lineHeight: 1.3 }}>
                        Review your items
                      </Typography>
                    </Box>
                    <Box sx={{ display: { xs: "block", sm: "none" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: "0.65rem", color: "text.primary", letterSpacing: "0.02em", lineHeight: 1.2 }}>
                        CART
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ flex: 1, height: "1px", backgroundColor: "#d1d5db", mx: { xs: 1, sm: 1.5, md: 3 } }} />

                  {/* Step 2 – Checkout (inactive) */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "6px", sm: "10px" }, flexShrink: 0 }}>
                    <Box
                      sx={{
                        width: { xs: 34, sm: 40, md: 48 },
                        height: { xs: 34, sm: 40, md: 48 },
                        borderRadius: "50%",
                        border: "1.5px solid #9ca3af",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#9ca3af",
                        flexShrink: 0,
                      }}
                    >
                      <CreditCardOutlinedIcon sx={{ fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.3rem" } }} />
                    </Box>
                    <Box sx={{ display: { xs: "none", sm: "block" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: { sm: "0.72rem", md: "0.85rem" }, color: "text.primary", letterSpacing: "0.03em", lineHeight: 1.3 }}>
                        CHECKOUT
                      </Typography>
                      <Typography sx={{ fontSize: { sm: "0.65rem", md: "0.75rem" }, color: "text.secondary", lineHeight: 1.3 }}>
                        Choose payment method
                      </Typography>
                    </Box>
                    <Box sx={{ display: { xs: "block", sm: "none" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: "0.65rem", color: "text.primary", letterSpacing: "0.02em", lineHeight: 1.2 }}>
                        CHECKOUT
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ flex: 1, height: "1px", backgroundColor: "#d1d5db", mx: { xs: 1, sm: 1.5, md: 3 } }} />

                  {/* Step 3 – Order Complete (active) */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "6px", sm: "10px" }, flexShrink: 0 }}>
                    <Box
                      sx={{
                        width: { xs: 34, sm: 40, md: 48 },
                        height: { xs: 34, sm: 40, md: 48 },
                        borderRadius: "50%",
                        backgroundColor: "#1a1a1a",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        flexShrink: 0,
                        border: "5px solid #e5e7eb",
                      }}
                    >
                      <CheckCircleOutlineOutlinedIcon sx={{ fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.3rem" } }} />
                    </Box>
                    <Box sx={{ display: { xs: "none", sm: "block" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: { sm: "0.72rem", md: "0.85rem" }, color: "text.primary", letterSpacing: "0.03em", lineHeight: 1.3 }}>
                        ORDER COMPLETE
                      </Typography>
                      <Typography sx={{ fontSize: { sm: "0.65rem", md: "0.75rem" }, color: "text.secondary", lineHeight: 1.3 }}>
                        Thank you for your order
                      </Typography>
                    </Box>
                    <Box sx={{ display: { xs: "block", sm: "none" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: "0.65rem", color: "text.primary", letterSpacing: "0.02em", lineHeight: 1.2 }}>
                        DONE
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Grid
                container
                justifyContent="center"
                alignItems="center"
                className="order-container"
              >
                {!loader &&
                  ([
                    "Order Placed",
                    "Confirmed",
                    "Packed",
                    "Shipped",
                    "Delivered",
                  ].includes(orderStatus) ? (
                    <Grid item xs={12} className="order-title">
                      <div className="icon-wrapper">
                        <CheckCircleOutlineIcon
                          sx={{ fontSize: { xs: "2rem", sm: "3rem" }, color: "#16a34a" }}
                        />
                      </div>
                      <Typography
                        sx={{
                          fontSize: { xs: "1rem", sm: "1.3rem" },
                          fontWeight: "bold",
                          color: "green",
                          mt: 1,
                        }}
                      >
                        {statusMessages[orderStatus]}
                      </Typography>
                      {storeName && (
                        <Typography
                          sx={{ fontSize: "0.9rem", color: "#6b7280", mt: 0.5 }}
                        >
                          Thank you for shopping with {storeName}.
                        </Typography>
                      )}
                      <Typography
                        sx={{ fontSize: "0.9rem", color: "#6b7280", mt: 0.5 }}
                      >
                        Order ID: <strong>#{orderid}</strong>
                      </Typography>
                      <Divider sx={{ mt:1 , width: "100%" }} />
                    </Grid>
                  ) : (
                    <Grid item xs={12} className="order-title">
                      <span className="title-hg-fail">{orderStatus}</span>
                      <br />
                      <div className="icon-wrapper-fail">
                        <SentimentDissatisfiedIcon />
                      </div>
                    </Grid>
                  ))}
              </Grid>
              <Grid container className="ordercomplete-content" spacing={4}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  lg={8}
                  className="order-container"
                >
                  <Grid container spacing={3}>
                    <ProductList
                      order={order}
                      productList={productList}
                      currencySymbol={currencySymbol}
                    />

                    {/* {productList.map((product, i) => 
                                        <div className='calc-wrapper'>
                                            <div className='product-detail'>
                                                <div className="image-wrapper">
                                                    <img 
                                                        src={_.get(product, 'product_detail.product_image')} 
                                                        alt={_.get(product, 'product_detail.name')} />
                                                </div>
                                                <div className="detail-wrapper">
                                                    <span className='title'>
                                                        {_.truncate(_.get(product, 'product_detail.name'), { length: 25 })}
                                                    </span>
                                                    <div className='quantity-wrapper'>
                                                        <span className='quantity'>Qty: {product.quantity}</span>
                                                    </div>
                                                    <div className='status-wrapper'>
                                                        <span className='status'>
                                                            {product.delivery_status_type}
                                                        </span>
                                                    </div>
                                                    <div className='status-wrapper'>
                                                        <span className='status'>
                                                            {order.selected_payment_mode.Name}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <span className='description'>
                                                <b>{formatCurrency.format(_.get(product, 'total_price', 0))}</b>
                                            </span>
                                        </div>
                                    )} */}
                    {/* </Grid> */}
                    {_.get(productList[0], "delivery_status") == 11 ? (
                      <Grid item xs={12} className="order-title">
                        <Button
                          onClick={() => navigate("/cart")}
                          variant="outlined"
                        >
                          Go Back To Cart
                        </Button>
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                {!loader ? (
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <div className="ordercomplete-summary">
                      <Typography
                        sx={{ fontSize: customeStyle.typography.subhading }}
                      >
                        ORDER DETAIL
                      </Typography>
                      {order?.total_price > 0 && (
                        <>
                          <Divider className="divider" />
                          <div className="calc-wrapper">
                            <span
                              className="description"
                              style={{ fontWeight: "500" }}
                            >
                              Subtotal
                            </span>
                            <span className=".descriptionvalue">
                              {/* <b>{GLOBAL_CURRENCY.symbol}{_.get(order, 'total_price')}</b> */}
                             {currencySymbol}{" "}
{Number(_.get(order, "total_price", 0)) +
  Number(_.get(order, "total_vat_amount", 0))}
                            </span>
                          </div>
                        </>
                      )}
                      {order?.tip_amount > 0 && (
                        <>
                          <Divider className="divider" />
                          <div className="calc-wrapper">
                            <span className="description">Tip Amount</span>
                            <span className=".descriptionvalue">
                              {/* <b>{GLOBAL_CURRENCY.symbol}{_.get(order, 'total_price')}</b> */}
                              {currencySymbol} {_.get(order, "tip_amount", 0)}
                            </span>
                          </div>
                        </>
                      )}
                      {order?.voucher_discount > 0 && (
                        <>
                          <Divider className="divider" />
                          <div className="calc-wrapper">
                            <span className="description">Coupon</span>
                            <span className=".descriptionvalue">
                              {currencySymbol}{" "}
                              {_.get(order, "voucher_discount", 0)}
                            </span>
                          </div>
                        </>
                      )}
                      {order?.shipping_charge > 0 && (
                        <>
                          <Divider className="divider" />
                          <div className="calc-wrapper">
                            <span className="description">Shipping</span>
                            <span className="descriptionvalue">
                              {currencySymbol}{" "}
                              {_.get(order, "shipping_charge", 0)}
                            </span>
                          </div>
                        </>
                      )}
                      <Divider className="divider" />
                      <div className="calc-wrapper">
                        <Typography
                          sx={{ fontSize: "0.9rem" }}
                          fontWeight="bold"
                        >
                          Total
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.9rem" }}
                          fontWeight="bold"
                          className="total-amt"
                        >
                          {currencySymbol} {_.get(order, "final_price", 0)}
                        </Typography>
                      </div>

                      <div
                        className="button-wrapper"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          marginTop: "12px",
                          width: "100%",
                        }}
                      >
                        {/* TRACK ORDER */}
                        <Button
                          fullWidth
                          variant="contained"
                          startIcon={<LocalShippingOutlinedIcon />}
                          sx={{
                            fontSize: "0.8rem",
                            textTransform: "none",
                            height: "40px",
                            borderRadius: "6px",
                            background: "#0f172a", // dark navy
                            "&:hover": {
                              background: "#020617",
                            },
                          }}
                          onClick={() =>
                            navigate(`/order-history?orderId=${orderid}`)
                          }
                        >
                          TRACK ORDER
                        </Button>

                        {/* CONTINUE SHOPPING */}
                        <Button
                          fullWidth
                          variant="outlined"
                          startIcon={<ShoppingBagOutlinedIcon />}
                          sx={{
                            fontSize: "0.8rem",
                            textTransform: "none",
                            height: "40px",
                            borderRadius: "6px",
                            borderColor: "#16a34a",
                            color: "#111827",
                            "&:hover": {
                              borderColor: "#15803d",
                              background: "#f0fdf4",
                            },
                          }}
                          onClick={() => navigate("/")}
                        >
                          CONTINUE SHOPPING
                        </Button>
                      </div>
                    </div>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </div>
        </Box>
      </Container>
    </CustomLayout>
  );
};
//
export default OrderComplete;
